import template from './index.html';
import pathes from './pathes.js';
import { mapFilters } from 'util/vue/map-filters';
import isMountedMixin from 'vue/mixins/is-mounted';


export default {
    mixins: [
        isMountedMixin,
    ],
    template,
    props: {
        variant: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pathes,
        };
    },
    computed: {
        imageSources() {
            const basePath = this.static(`img/courses/im_bild0${ this.variant }`);

            return [
                `${ basePath }.jpg`,
                `${ basePath }@2x.jpg`,
            ];
        },
    },
    methods: {
        ...mapFilters(['static']),
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/components/cms-placeholders/entry-animation/index.js